import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import styles from './CostCalculator.module.scss'
import { Row, Container, Col, Button, Form, Image } from 'react-bootstrap'
import { CustomTextField } from '../shared/customTextField'
import { CustomButton } from '../shared/customButton'
import { CustomAlertBox } from '../shared/customAlertBox'
import { Formik } from 'formik';
import * as yup from 'yup';
import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';



const CostCalculator = () => {

    let [step, setStep] = useState(1);

    let [inputData, SetinputData] = useState();

    //states for set number of candidates
    let [CandidateNo, SetCandidateNo] = useState(0);
    let [Candidate200, SetCandidate200] = useState(0);
    let [Candidate1000, SetCandidate1000] = useState(0);
    let [Candidate1200, SetCandidate1200] = useState(0);

    //states to set cost of candidates
    let [totalCandidateCost, setTotalCandidateCost] = useState(0);
    let [candidateCost200, setCandidateCost200] = useState(0);
    let [candidateCost1000, setCandidateCost1000] = useState(0);
    let [candidateCost1200, setCandidateCost1200] = useState(0);

    //states to set cost for video interview
    let [noOfInterviewers, setNoOfInterviewers] = useState(0);
    let [interviewMinutes, setInterviewMinutes] = useState(0);
    let [interviewsPerMonth, setInterviewPerMonth] = useState(0);
    let [attendeePerInterview, setAttendeePerInterview] = useState(0);
    let [attendeeMinutes, setAttendeeMinutes] = useState(0);
    let [perInterviewCost, setPerInterviewCost] = useState(0);
    let [TotalInterviewCost, setTotalInterviewCost] = useState(0);

    //state to set total monthly cost
    let [totalMonthlyCost, setTotalMonthlyCost] = useState(0);

    //const for per candidate fee
    const cost_per_candidate_first_200 = 0.4;
    const cost_per_candidate_next_1000 = 0.3;
    const cost_per_candidate_above_1200 = 0.2;

    //const for per video interview minute
    const cost_per_interview_minute = 0.003;



    //onsubmit function
    const onSubmit = (values) => {
        setStep(2);
        SetinputData(values);
        SetCandidateNo(values.candidateNo);
        calcCandidates(values.candidateNo);

        let minutes = parseInt(values.interviewMinutes);
        let interviewers = parseInt(values.interviewerNo);

        if (isNaN(minutes) && isNaN(interviewers)) {
            values.interviewMinutes = 0;
            values.interviewerNo = 0

            calcInterviewCost(values.interviewerNo, values.interviewMinutes, values.interviewsPerMonth);

        } else {
            calcInterviewCost(values.interviewerNo, values.interviewMinutes, values.interviewsPerMonth);

        }

        setInterviewPerMonth(values.interviewsPerMonth);
        TotalMonthlyCost();



    }

    //calcualte total candidates cost
    const calcCandidates = (values) => {
        if (values <= 200) {
            SetCandidate200(values);
            let total = cost_per_candidate_first_200 * values;
            //const noZeroes = parseFloat(total.toFixed(3))

            setCandidateCost200(parseFloat(total.toFixed(2)));
            setTotalCandidateCost(parseFloat(total.toFixed(2)));
        }
        else if (values <= 1200) {
            SetCandidate200(200)
            let candidates = values - 200;
            SetCandidate1000(candidates);
            let total200 = (200 * cost_per_candidate_first_200);
            let total1000 = (candidates * cost_per_candidate_next_1000);
            setCandidateCost200(total200);
            setCandidateCost1000(total1000);
            let total = (200 * cost_per_candidate_first_200) + (candidates * cost_per_candidate_next_1000);
            setTotalCandidateCost(parseFloat(total.toFixed(2)));

        }
        else {
            SetCandidate200(200);
            SetCandidate1000(1000);
            let candidates = values - 1200;
            SetCandidate1200(candidates);
            let total200 = (200 * cost_per_candidate_first_200);
            let total1000 = (1000 * cost_per_candidate_next_1000);
            let total1200 = (candidates * cost_per_candidate_above_1200)
            setCandidateCost200(total200);
            setCandidateCost1000(total1000);
            setCandidateCost1200(parseFloat(total1200.toFixed(2)));
            let total = (200 * cost_per_candidate_first_200) + (1000 * cost_per_candidate_next_1000) + (candidates * cost_per_candidate_above_1200);
            setTotalCandidateCost(parseFloat(total.toFixed(2)));
        }

    }

    //calculate total interview cost
    const calcInterviewCost = (interviewers, minutes, interviewPerMonths) => {
        setInterviewMinutes(minutes);
        setNoOfInterviewers(interviewers);
        let totalAttendees = parseInt(interviewers) + 1;
        let attendeeMinPerInterview = totalAttendees * minutes;
        let perInterviewCost = attendeeMinPerInterview * cost_per_interview_minute;
        let totalInterviewCost = perInterviewCost.toFixed(2) * interviewPerMonths;
        setAttendeePerInterview(totalAttendees);
        setAttendeeMinutes(attendeeMinPerInterview);
        setPerInterviewCost(parseFloat(perInterviewCost.toFixed(2)));
        setTotalInterviewCost(parseFloat(totalInterviewCost.toFixed(2)))

    }

    //calculate total cost
    const TotalMonthlyCost = () => {
        let TotalMonthlyCost = totalCandidateCost + TotalInterviewCost;
        calcTotal(parseFloat(TotalMonthlyCost.toFixed(2)));
    }

    const calcTotal = (total) => {
        setTotalMonthlyCost(total);
    }

    const schema = yup.object().shape({
        candidateNo: yup.number().typeError('Only numbers allowed').required('Required').integer().moreThan(-1),
        interviewsPerMonth: yup.number().typeError('Only numbers allowed').required('Required').integer('Invalid input').moreThan(-1, 'Invalid input'),
        interviewerNo: yup.number().typeError('Only numbers allowed').when(
            'interviewsPerMonth', {
            is: (interviewsPerMonth) => interviewsPerMonth > 0,
            then: yup.number().required('Required')
        }
        ).integer('Invalid input').moreThan(-1, 'invalid input'),
        interviewMinutes: yup.number().typeError('Only numbers allowed').when(
            'interviewsPerMonth', {
            is: (interviewsPerMonth) => interviewsPerMonth > 0,
            then: yup.number().required('Required')
        }
        ).integer('Invalid input').moreThan(-1, 'Invalid input')
    })

    useEffect(() => {
        TotalMonthlyCost();
    }, [totalMonthlyCost, totalCandidateCost, TotalInterviewCost])



    const GetDetails = () => {
        return (
            <>

                <Formik
                    validationSchema={schema}
                    initialValues={{
                        candidateNo: 0,
                        interviewerNo: '',
                        interviewMinutes: '',
                        interviewsPerMonth: 0,

                    }}
                    onSubmit={(values) => { onSubmit(values) }}

                >
                    {({
                        values,
                        handleSubmit,
                        handleChange,
                        submitCount,
                        errors,

                    }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Row>
                                <Col className={styles.alertBoxTop}>
                                    <CustomAlertBox
                                        alertType="dangerAlert"
                                        alertBodyText="Enter these values to calculate the estimated monthly cost of using HireTrace."
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col >
                                    <p className={styles.stepSubtopicName}>
                                        Candidate Cost Calculation  (enter average values)
                                    </p>
                                </Col>
                            </Row>
                            <Row className='mt-3'>
                                <Col sm={5} md={6} lg={5} xl={7} className="pl-4">
                                    <p className={styles.TopicLabelFirstPage}>How many new candidates apply for your company per month ?  </p>
                                </Col>
                                <Col className="align-self-center">

                                    <CustomTextField
                                        //label="Stage Name"
                                        name="candidateNo"
                                        classLabel="defaultLabel"
                                        controlId="candidateNo"
                                        placeholder="Number of candidates"
                                        type="text"
                                        disabled={false}
                                        value={values.candidateNo}
                                        classType="defaultTextBox"
                                        handleOnChange={handleChange}
                                        errorMessage={errors.candidateNo}
                                        isInvalid={submitCount > 0 && !!errors.candidateNo}
                                    />
                                </Col>

                            </Row>
                            <Row>
                                <Col >
                                    <p className={styles.stepSubtopicName2}>
                                        Video Interview Cost Calculation  (enter average values)
                                    </p>
                                </Col>
                            </Row>
                            <Row className='mt-3'>
                                <Col sm={5} md={6} lg={5} xl={7} className="pl-4">
                                    <p className={styles.TopicLabelFirstPage}>How many video interviews you have per month ?  </p>
                                </Col>
                                <Col className="align-self-center">

                                    <CustomTextField
                                        //label="Stage Name"
                                        name="interviewsPerMonth"
                                        classLabel="defaultLabel"
                                        controlId="interviewsPerMonth"
                                        placeholder="Interviews per month"
                                        type="text"
                                        disabled={false}
                                        value={values.interviewsPerMonth}
                                        classType="defaultTextBox"
                                        handleOnChange={handleChange}
                                        errorMessage={errors.interviewsPerMonth}
                                        isInvalid={submitCount > 0 && !!errors.interviewsPerMonth}
                                    />
                                </Col>

                            </Row>
                            <Row className='mt-3'>
                                <Col sm={5} md={6} lg={5} xl={7} className="pl-4">
                                    <p className={styles.TopicLabelFirstPage}>How many Interviewers participate for a
                                        single video interview ?  </p>
                                </Col>
                                <Col className="align-self-center">

                                    <CustomTextField
                                        //label="Stage Name"
                                        name="interviewerNo"
                                        classLabel="defaultLabel"
                                        controlId="interviewerNo"
                                        placeholder="Number of Interviewers"
                                        type="text"
                                        disabled={values.interviewsPerMonth > 0 ? false : true}
                                        value={values.interviewerNo}
                                        classType="defaultTextBox"
                                        handleOnChange={handleChange}
                                        errorMessage={errors.interviewerNo}
                                        isInvalid={submitCount > 0 && !!errors.interviewerNo}
                                    />
                                </Col>

                            </Row>
                            <Row className='mt-3'>
                                <Col sm={5} md={6} lg={5} xl={7} className="pl-4">
                                    <p className={styles.TopicLabelFirstPage}>How long it will take for a single video interview (in
                                        minutes)  ?  </p>
                                </Col>
                                <Col className="align-self-center">

                                    <CustomTextField
                                        //label="Stage Name"
                                        name="interviewMinutes"
                                        classLabel="defaultLabel"
                                        controlId="interviewMinutes"
                                        placeholder="Video interview minutes"
                                        type="text"
                                        disabled={values.interviewsPerMonth > 0 ? false : true}
                                        value={values.interviewMinutes}
                                        classType="defaultTextBox"
                                        handleOnChange={handleChange}
                                        errorMessage={errors.interviewMinutes}
                                        isInvalid={submitCount > 0 && !!errors.interviewMinutes}
                                    />
                                </Col>

                            </Row>


                            <Row className={styles.actionBtns}>
                                <Col className="pl-0">

                                    <CustomButton
                                        buttonType="button"
                                        label="Back"
                                        type="defaultBtn"
                                    //handleClick={() => props.previousPage(1)}

                                    />

                                </Col>
                                <Col className="pr-0">

                                    <CustomButton
                                        buttonType="submit"
                                        label="Submit"
                                        type="primaryBtn"
                                    //disabled={state === true ? true : false}
                                    //backicon={
                                    //state === true ? (<i className="fas fa-circle-notch fa-spin"></i>)
                                    //  : ''
                                    //}
                                    //handleClick={() => submitDetails()}
                                    />
                                </Col>
                            </Row>



                        </Form>

                    )}

                </Formik>

            </>
        )
    }

    const Calculation = () => {
        return (
            <>
                <Row className='mt-3'>
                    <Col >
                        <p className={styles.stepSubtopicName2}>
                            Candidate Cost Calculation
                        </p>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col className={styles.rowData}>
                        <Row>
                            <Col sm={3} md={6} lg={5} xl={7} >
                                <p className={styles.TopicLabels}>a. New candidates per month  </p>
                            </Col>
                            <Col sm={1} lg={3}>
                            </Col>
                            <Col sm={1} lg={2}>
                                <p className={styles.TopicValue}>{CandidateNo}</p>
                            </Col>

                        </Row>
                        <Row >
                            <Col sm={3} md={6} lg={5} xl={7} >
                                <Row>
                                    <p className={styles.subTopicLabels} >b. Cost for first 200 candidates</p>
                                    <div className={styles.ToolTip}>
                                        <svg data-tip data-for="cost_200" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                        <ReactTooltip id="cost_200" place="right" type="dark" effect="solid" clickable={true}>
                                            <div className={styles.toolTipBox}>{<p>We charge $0.4 per candidate for the  first 200 candidates</p>}</div>
                                        </ReactTooltip>
                                    </div>
                                </Row>
                            </Col>
                            <Col sm={1} lg={3} >
                                <p className={styles.subTopicValues}>{Candidate200} x  $ {cost_per_candidate_first_200}</p>
                            </Col>
                            <Col sm={1} lg={2}>
                                <p className={styles.subTopicValues}>$ {candidateCost200}</p>
                            </Col>

                        </Row>
                        <Row >
                            <Col>
                                <Row>
                                    <p className={styles.subTopicLabels} >c. Cost for Next  1000 candidates </p>
                                    <div className={styles.ToolTip}>
                                        <svg data-tip data-for="cost_1000" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                        <ReactTooltip id="cost_1000" place="right" type="dark" effect="solid" clickable={true}>
                                            <div className={styles.toolTipBox}>{<p>We charge $0.3 per candidate for the  next 1000 candidates</p>}</div>
                                        </ReactTooltip>
                                    </div>
                                </Row>
                            </Col>
                            <Col lg={3}>
                                <p className={styles.subTopicValues}>{Candidate1000} x $ {cost_per_candidate_next_1000} </p>
                            </Col>
                            <Col lg={2}>
                                <p className={styles.subTopicValues}>$ {candidateCost1000}</p>
                            </Col>

                        </Row>
                        <Row >
                            <Col>
                                <Row>
                                    <p className={styles.subTopicLabels} >d. Cost for above 1200 candidates </p>
                                    <div className={styles.ToolTip}>
                                        <svg data-tip data-for="cost_1200" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                        <ReactTooltip id="cost_1200" place="right" type="dark" effect="solid" clickable={true}>
                                            <div className={styles.toolTipBox}>{<p>We charge $0.2 per candidate for above 1200 candidates</p>}</div>
                                        </ReactTooltip>
                                    </div>
                                </Row>
                            </Col>
                            <Col lg={3}>
                                <p className={styles.subTopicValues}>{Candidate1200} x $ {cost_per_candidate_above_1200}</p>
                            </Col>
                            <Col lg={2}>
                                <p className={styles.subTopicValues}>$ {candidateCost1200}</p>
                            </Col>

                        </Row>
                        <Row className='mt-3'>
                            <Col sm={5} md={6} lg={5} xl={7} >
                                <p className={styles.TopicLabelHighlight}>e. Total cost for Candiates ( b + c + d ) </p>
                            </Col>
                            <Col lg={3}>
                            </Col>
                            <Col lg={2}>
                                <p className={styles.TopicValueHighlighted}>$ {totalCandidateCost}</p>
                            </Col>

                        </Row>


                        <Row >
                            <Col >
                                <p className={styles.stepSubtopicName2}>
                                    Video Interview  Cost Calculation
                                </p>
                            </Col>
                        </Row>
                        <Row className='mt-3'>
                            <Col sm={5} md={6} lg={5} xl={7} >
                                <p className={styles.TopicLabels}>f. Interviewers per interview </p>
                            </Col>
                            <Col lg={3}>
                            </Col>
                            <Col lg={2}>
                                <p className={styles.TopicValue}>{noOfInterviewers}</p>
                            </Col>

                        </Row>
                        <Row>
                            <Col sm={5} md={6} lg={5} xl={7} >
                                <p className={styles.TopicLabels}>g. Avg Interview duration in minutes </p>
                            </Col>
                            <Col lg={3}>
                            </Col>
                            <Col lg={2}>
                                <p className={styles.TopicValue}>{interviewMinutes} mins</p>
                            </Col>

                        </Row>
                        <Row>
                            <Col sm={5} md={6} lg={5} xl={7} >
                                <p className={styles.TopicLabels}>h. Interviews per month </p>
                            </Col>
                            <Col lg={3}>
                            </Col>
                            <Col lg={2}>
                                <p className={styles.TopicValue}>{interviewsPerMonth}</p>
                            </Col>

                        </Row>
                        <Row >
                            <Col>
                                <Row>
                                    <p className={styles.subTopicLabels} >i. Total attendees per interview (f + 1 )</p>
                                    <div className={styles.ToolTip}>
                                        <svg data-tip data-for="total_attendee" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                        <ReactTooltip id="total_attendee" place="right" type="dark" effect="solid" clickable={true}>
                                            <div className={styles.toolTipBox}>{<p>Number of attendees = Number of interviewers + candidate</p>}</div>
                                        </ReactTooltip>
                                    </div>
                                </Row>
                            </Col>
                            <Col lg={3} >
                                <p className={styles.subTopicValues}>{noOfInterviewers} + 1</p>
                            </Col>
                            <Col lg={2}>
                                <p className={styles.subTopicValues}>{attendeePerInterview}</p>
                            </Col>

                        </Row>
                        <Row >
                            <Col>
                                <Row>
                                    <p className={styles.subTopicLabels} >j. Attendee minutes per interview (i x g)</p>
                                    <div className={styles.ToolTip}>
                                        <svg data-tip data-for="attendee_minutes" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                        <ReactTooltip id="attendee_minutes" place="right" type="dark" effect="solid" clickable={true}>
                                            <div className={styles.toolTipBox}>{<p>Attendee minutes per interview =  (Number of attendees per interview) x (minutes per interview)</p>}</div>
                                        </ReactTooltip>
                                    </div>
                                </Row>
                            </Col>
                            <Col lg={3} >
                                <p className={styles.subTopicValues}>{interviewMinutes} x {attendeePerInterview}</p>
                            </Col>
                            <Col lg={2}>
                                <p className={styles.subTopicValues}> {attendeeMinutes} mins</p>
                            </Col>

                        </Row>
                        <Row >
                            <Col>
                                <Row>
                                    <p className={styles.subTopicLabels} >k. Per interview cost ( j X $ {cost_per_interview_minute})</p>
                                    <div className={styles.ToolTip}>
                                        <svg data-tip data-for="per_interview_cost" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                        <ReactTooltip id="per_interview_cost" place="right" type="dark" effect="solid" clickable={true}>
                                            <div className={styles.toolTipBox}>{<p>We charge $0.003 per attendee minute, So, Per interview Cost = (Attendee minutes per interview)  x ($0.003)</p>}</div>
                                        </ReactTooltip>
                                    </div>
                                </Row>
                            </Col>
                            <Col lg={3} >
                                <p className={styles.subTopicValues}>{attendeeMinutes}  x $ {cost_per_interview_minute}</p>
                            </Col>
                            <Col lg={2}>
                                <p className={styles.subTopicValues}> $ {perInterviewCost}</p>
                            </Col>

                        </Row>
                        <Row className='mt-3 pl-3'>
                            <Col sm={5} md={6} lg={5} xl={7} >
                                <Row className="">
                                    <p className={styles.TopicLabelHighlight}>m. Total cost for Video Interviews  ( k x h )</p>
                                    <div className={styles.ToolTip}>
                                        <svg data-tip data-for="total_interview_cost" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                        <ReactTooltip id="total_interview_cost" place="right" type="dark" effect="solid" clickable={true}>
                                            <div className={styles.toolTipBox}>{<p>Total Cost for Video Interviews = Number of interviews + cost per interview</p>}</div>
                                        </ReactTooltip>
                                    </div>
                                </Row>
                            </Col>
                            <Col lg={3}>
                            </Col>
                            <Col lg={2}>
                                <p className={styles.TopicValueHighlighted}>$ {TotalInterviewCost}</p>
                            </Col>

                        </Row>


                        <Row className='align-center'>
                            <Col>
                                <Row className={styles.totalLabelRow}>
                                    <p className={styles.TotalLabel}>
                                        Total Monthly Cost (e + m )
                                    </p>
                                    <div className={styles.ToolTipTotal}>
                                        <svg data-tip data-for="total_cost" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                        <ReactTooltip id="total_cost" place="right" type="dark" effect="solid" clickable={true}>
                                            <div className={styles.toolTipBox}>{<p>Total Cost  = Total Cost for Candidates + Total Cost for Interviews</p>}</div>
                                        </ReactTooltip>
                                    </div>
                                    <p className={styles.TotalLabel1}> :</p>
                                </Row>

                            </Col>

                            <Col lg={4}>
                                <p className={styles.TotalValue}>
                                    $ {totalMonthlyCost}
                                </p>
                            </Col>
                        </Row>

                        <Row className={styles.actionBtns}>
                            <Col className="pl-0">
                                <CustomButton
                                    buttonType="button"
                                    label="Calculate Again"
                                    type="defaultBtn"
                                    handleClick={() => setStep(1)}

                                />
                            </Col>
                            <Col className="pr-0">
                                <Link to="/signup">
                                    <CustomButton
                                        buttonType="submit"
                                        label="Start Free Trial"
                                        type="primaryBtn"
                                    //disabled={state === true ? true : false}
                                    //backicon={
                                    //state === true ? (<i className="fas fa-circle-notch fa-spin"></i>)
                                    //  : ''
                                    //}
                                    //handleClick={() => submitDetails()}
                                    />
                                </Link>
                            </Col>
                        </Row>

                    </Col>
                </Row >
            </>
        )
    }




    return (
        <div>
            <Helmet>
                <title>Cost Calculator | HireTrace</title>
            </Helmet>
            <Row className={styles.loginBackgroundColor}>
                <Container>
                    <Row>
                        <Col xs={{}} md={{ span: 8, offset: 2 }}>
                            <div className={styles.loginBox}>
                                <Container className={styles.innerBoxContainer}>

                                    <Col sm={{ span: 8, offset: 2 }} className={styles.companyLogoDiv}>
                                        <div className={styles.companySecondLogoDiv}>
                                            <a href="/" target="_blank" rel="noreferrer">
                                                <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/favicon (1).ico`} rounded fluid className={styles.companyLogo} />
                                            </a>
                                        </div>
                                    </Col>

                                    <div className={styles.modalHeaderDiv}>
                                        <h2 className={styles.modalHeader}>Estimated Monthly Cost Calculator</h2>
                                    </div>

                                    <Col xs={{ span: 4, offset:  4}} className={styles.stepPosition}>
                                        <div className={step === 1 ? `${styles.roundStepMainDiv}` : step === 2 ? `${styles.roundStepMainDiv} ${styles.roundStepMainDiv2}` : `${styles.roundStepMainDiv}`}>
                                            <div className={styles.stepActive}>
                                                {
                                                    step === 1 ?
                                                        <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g id="Content">
                                                                <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                                <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                                            </g>
                                                        </svg>
                                                        :
                                                        <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clip-path="url(#clip0_613_29628)">
                                                                <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_613_29628">
                                                                    <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                }

                                            </div>
                                            <div className={(step === 2) ? styles.stepActive : ''}>
                                                {
                                                    step === 2 ?
                                                        <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g id="Content">
                                                                <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                                <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                                            </g>
                                                        </svg>
                                                        :
                                                        (step === 2) ?
                                                            <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <g clip-path="url(#clip0_613_29628)">
                                                                    <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0_613_29628">
                                                                        <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                                    </clipPath>
                                                                </defs>
                                                            </svg>
                                                            :
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <g clip-path="url(#clip0_613_29582)">
                                                                    <rect width="24" height="24" rx="12" fill="#F9FAFB" />
                                                                    <circle cx="12" cy="12" r="4" fill="#D0D5DD" />
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0_613_29582">
                                                                        <rect width="24" height="24" rx="12" fill="white" />
                                                                    </clipPath>
                                                                </defs>
                                                            </svg>
                                                }
                                            </div>
                                        </div>
                                    </Col>


                                    <Col sm={12}>
                                        <Container>
                                            {
                                                step == 1 ? (
                                                    <>
                                                        <GetDetails />
                                                    </>
                                                )
                                                    : null
                                            }
                                            {
                                                step == 2 ? (
                                                    <>
                                                        <Calculation />
                                                    </>
                                                )
                                                    : null
                                            }
                                            {/* Rendering Content Goes Here
                                            {step === 1  && <StageDetailsConfiguration nextPage={nextPage} setSubmitValues={setSubmitValues} values={values} />}
                                            {step === 2  && <Review nextPage={nextPage} previousPage={previousPage} values={values} handleClose={props.handleClose} refreshData={props.refreshData} GetTaskValues={props.GetTaskValues} />} */}
                                        </Container>
                                    </Col>

                                </Container>
                            </div>
                        </Col>

                    </Row>

                </Container>
            </Row>


        </div>
    )
}

export default CostCalculator
